// 礼包反馈引流入口信息相关
import { getGiftFeedbackInfo } from '@/api/giftCenter'
export function initEntryInfo (page_type, pop_up_type) {
  return {
    data () {
      return {
        entryInfo: {
          button_name: '其他惊喜福利'
        },
      }
    },
    mounted () {
      this.onGetGiftFbExtraInfo()
    },
    methods: {
      // 获取礼包反馈引流信息
      onGetGiftFbExtraInfo () {
        getGiftFeedbackInfo({
          page_type,
          pop_up_type,
        }).then(res => {
          console.log('-->', res)
          const { button_name, url } = res.data || {}
          if (url) {
            this.entryInfo = res.data
          }
        })
      },
      // 点击引流按钮
      onClickEntry (...args) {
        const { url } = this.entryInfo
        this.beforeEntry(...args)
        if (!url) {
          this.$toast('敬请期待')
          return
        }
        if (this.jumpLoading) return
        this.jumpLoading = true
        this.afterClickEntry(...args)
        setTimeout(() => {
          this.handleCloseDialog(...args)
          this.jumpLoading = false
          window.location.href = url;
          // window.open(url, '_self')
        }, 200);
      },
      handleCloseDialog () {},
      beforeEntry () {},
      afterClickEntry () {},
    },
  }
}